import {mapiqApi} from '@lib/infrastructure';
import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../../createStore';
import {getIsExtrasFeatureEnabled} from '../../infrastructure';
import {Extra} from '../entities';
import {getBuildingEntities} from '../buildings';
import {ExtraServicesByCategoryByBuildingIdType} from './types';
import {getEmptyServicesByCategoryAndBuildingId, groupServicesByCategoryAndBuildingId} from './utils';

export const loadExtras = createAsyncThunk<Extra[], void, AppThunkApiConfig>(
  'extras/loadExtras',
  async (_, {extra, getState}) => {
    const isExtrasFeatureEnabled = getIsExtrasFeatureEnabled(getState());

    if (!isExtrasFeatureEnabled) {
      return [];
    }
    const client = extra.apiClient;
    const api = mapiqApi(client);
    const response = await api.getExtras();

    return response;
  },
);

export const loadExtraServices = createAsyncThunk<ExtraServicesByCategoryByBuildingIdType, void, AppThunkApiConfig>(
  'extras/loadExtraServices',
  async (_, {extra, getState}) => {
    const isExtrasFeatureEnabled = getIsExtrasFeatureEnabled(getState());

    if (!isExtrasFeatureEnabled) {
      return getEmptyServicesByCategoryAndBuildingId();
    }

    const client = extra.apiClient;
    const api = mapiqApi(client);

    const response = await api.getExtraServices();

    const allAvailableBuildings = getBuildingEntities(getState());

    return groupServicesByCategoryAndBuildingId(response, allAvailableBuildings);
  },
);
